export const getSortDescription = (column, columns) => {
  const gridColumn = columns.find((c) => c.field === column.field )
  return gridColumn && gridColumn.onSortField
}
